var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0292494 5.81291C-0.212128 4.15775 1.07119 2.67371 2.74386 2.67371H10.27C11.9427 2.67371 13.226 4.15775 12.9846 5.81291L11.5497 15.6525C11.3531 17.0004 10.1972 18 8.83506 18H4.1788C2.81662 18 1.66076 17.0004 1.46419 15.6525L0.0292494 5.81291ZM2.74386 4.31008C2.06892 4.31008 1.55109 4.9089 1.64849 5.57677L3.08343 15.4164C3.16275 15.9603 3.62915 16.3636 4.1788 16.3636H8.83506C9.38471 16.3636 9.85111 15.9603 9.93043 15.4164L11.3654 5.57677C11.4628 4.9089 10.9449 4.31008 10.27 4.31008H2.74386Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97754 0.818185C3.97754 0.366314 4.34385 0 4.79572 0H8.2182C8.67007 0 9.03638 0.366314 9.03638 0.818185C9.03638 1.27006 8.67007 1.63637 8.2182 1.63637H4.79572C4.34385 1.63637 3.97754 1.27006 3.97754 0.818185Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85819 8.05384C4.17396 8.00874 4.4665 8.22814 4.51161 8.54391L5.36723 14.5332C5.41234 14.849 5.19293 15.1415 4.87717 15.1866C4.5614 15.2318 4.26886 15.0123 4.22375 14.6966L3.36813 8.70726C3.32302 8.3915 3.54243 8.09895 3.85819 8.05384Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13643 15.1867C7.82067 15.1416 7.60127 14.8491 7.64637 14.5333L8.50199 8.54398C8.5471 8.22822 8.83964 8.00881 9.15541 8.05392C9.47117 8.09903 9.69058 8.39157 9.64547 8.70733L8.78985 14.6967C8.74474 15.0124 8.4522 15.2318 8.13643 15.1867Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5065 15.1926C6.18753 15.1926 5.92896 14.934 5.92896 14.615L5.92896 8.6257C5.92896 8.30673 6.18753 8.04816 6.5065 8.04816C6.82546 8.04816 7.08404 8.30673 7.08404 8.6257L7.08404 14.615C7.08404 14.934 6.82546 15.1926 6.5065 15.1926Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.51abca463dea2b106281ed243032cd0f.svg";
export { ForwardRef as ReactComponent };